module.exports = {
  root: {
    RPC: process.env.REACT_APP_ETHEREUM_PROVIDER_URL,
    RootChainManagerProxy: process.env.REACT_APP_ROOT_CHAIN_MANAGER_PROXY,
    DERC20: '0x655F2166b0709cd575202630952D71E2bB0d61Af',
    posERC20Predicate: '0xdD6596F2029e6233DEFfaCa316e6A95217d4Dc34',
  },
  child: {
    RPC: process.env.REACT_APP_POLYGON_PROVIDER_URL,
    DERC20: '0xfe4F5145f6e09952a5ba9e956ED0C25e3Fa4c7F1',
  },
};
